<template>
    <v-container>
                <td>
                  <v-text-field
                    class="pt-10"
                    style="width: 80px;"
                    single-line
                    outlined
                    v-model="itemQuantity"
                    type="number"
                    min="0"
                  ></v-text-field>
                </td>
    </v-container>
</template>

<script>
//  this component will emit the price * quantity when created
// after creatino, it will emit teh total under the itemQuantity watch
export default {
    name: 'CartItemCard',
    data: () =>({
      itemQuantity: 1,

    }),
    props:{
      cartItemDetail:{
        type: Object,
        required: true
      }
    },
    watch: {
      itemQuantity: function(itemQuantity) {
      // console.log("Quantity update", this.cartItemDetail)
      // push the cart item detail and update quantity * price
      const newPrice = this.cartItemDetail.price * itemQuantity
      // this.$emit('item-quantity', itemQuantity);
      // update the total price for the product
      this.$store.commit("updateTotalPrice", {itemTitle: this.cartItemDetail.title, itemTotal: newPrice});
        }
      }       
}
</script>


// WEBPACK FOOTER //
// src/components/Cart/CartItemCard.vue